import { STICKER_PACK } from "../apiConstant";
import BaseApi from "../baseApi";

class StickerPackApi extends BaseApi {
    constructor() {
        super();
        this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
        this.$axiosInstance = this.initAxiosInstance();
    }

    createStickerPack(body) {
        return this.post(`${STICKER_PACK}/create`, body);
    }

    updateStickerPack(body) {
        return this.post(`${STICKER_PACK}/update`, body);
    }

    deleteStickerPack(stickerPackId) {
        return this.post(`${STICKER_PACK}/delete/${stickerPackId}`);
    }

    getStickerPacks(body) {
        return this.post(`${STICKER_PACK}/list`, body);
    }

    getStickerPacksWithStickers(body) {
        return this.post(`${STICKER_PACK}/with-stickers`, body);
    }

}
export default StickerPackApi;
